import { Alert, AlertTitle, Card, CardContent, CardHeader, FormControlLabel, FormLabel, Grid, Grid2, InputAdornment, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { APP_HOST, FORM_TYPE, JENJANG_PENDIDIKAN } from "../../helper/Constant";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";
import GridForm from "../general/GridForm";
import GridDdlPlace from "../general/GridDdlPlace";
import dayjs from "dayjs";

function DataWali({ handleChange, data, isPenanggungJawab = false }) {
    const [isLoadingProvinsi, setIsLoadingProvinsi] = useState(true);
    const [isLoadingKabupaten, setIsLoadingKabupaten] = useState(true);
    const [isLoadingKecamatan, setIsLoadingKecamatan] = useState(true);
    const [isLoadingKelurahan, setIsLoadingKelurahan] = useState(true);
    const [provinsis, setProvinsis] = useState([]);
    const [kabupatens, setKabupatens] = useState([]);
    const [kecamatans, setKecamatans] = useState([]);
    const [kelurahans, setKelurahans] = useState([]);

    const GetKabupaten = (provinsiId) => {
        setIsLoadingKabupaten(true);
        Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
            .then((dataResponse) => {
                setKabupatens(dataResponse);
                setKecamatans([]);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKabupaten(false);
            });
    }

    const GetKecamatan = (kabupatenId) => {
        setIsLoadingKecamatan(true);
        Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
            .then((dataResponse) => {
                setKecamatans(dataResponse);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKecamatan(false);
            });
    }

    const GetKelurahan = (kecamatanId) => {
        setIsLoadingKelurahan(true);
        Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
            .then((dataResponse) => {
                setKelurahans(dataResponse);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKelurahan(false);
            });
    }

    useEffect(() => {
        setIsLoadingProvinsi(true);
        Commons.GetData(APP_HOST + '/alamat/provinsi')
            .then((dataResponse) => {
                setProvinsis(dataResponse);
                setIsLoadingProvinsi(false);
                if (data?.provinsi && data?.kabupaten && data?.kecamatan && data?.kelurahan) {
                    setIsLoadingKabupaten(true);
                    let provinsiId = dataResponse.find((item) => item.nama_provinsi === data.provinsi).id_provinsi;
                    Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
                        .then((dataKabupaten) => {
                            setKabupatens(dataKabupaten);
                            setIsLoadingKabupaten(false);
                            setIsLoadingKecamatan(true);
                            let kabupatenId = dataKabupaten.find((item) => item.nama_kabupaten_kota === data.kabupaten).id_kabupaten_kota;
                            Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
                                .then((dataKecamatan) => {
                                    setKecamatans(dataKecamatan);
                                    setIsLoadingKecamatan(false);
                                    setIsLoadingKelurahan(true);
                                    let kecamatanId = dataKecamatan.find((item) => item.nama_kecamatan === data.kecamatan).id_kecamatan;
                                    Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
                                        .then((dataKelurahan) => {
                                            setKelurahans(dataKelurahan);
                                            setIsLoadingKelurahan(false);
                                        });
                                });

                        });
                }
            })
            .catch((errResponse) => {
                console.log(errResponse);
            });
    }, []);

    return (
        <>
            <Card>
                <CardHeader title="Data Wali" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ mt: '20px', padding: '10px' }} container spacing={2}>
                        {/* Row */}
                        <GridForm column={4} titleForm={"Nama Wali"} attribute={{ name: "nama_wali", value: data?.nama_wali }} isRequired={true} handleChange={handleChange}></GridForm>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Pendidikan Terakhir</FormLabel>
                            <Select required name="pendidikan" value={data?.pendidikan}
                                onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(JENJANG_PENDIDIKAN).map(([key, value]) => {
                                        return (
                                            <MenuItem value={value} key={key}>{value}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <GridDdlPlace columns={4} titleForm={"Provinsi"} isRequired={true} attribute={{ name: "provinsi", value: data?.provinsi }}
                            datahandler={(e) => {
                                handleChange(e.target.name, e.target.value);
                                GetKabupaten(provinsis.find((item) => item.nama_provinsi === e.target.value).id_provinsi);
                            }} datas={{ data: provinsis, keyName: "id_provinsi", valueName: "nama_provinsi" }}
                            isLoading={isLoadingProvinsi}></GridDdlPlace>

                        {/* Row */}
                        <GridForm column={4} titleForm={"Alamat"} attribute={{ name: "alamat", value: data?.alamat, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Jurusan Pendidikan (Optional)"} attribute={{ name: "jurusan_pendidikan", value: data?.jurusan_pendidikan }} isRequired={false} handleChange={handleChange}></GridForm>
                        <GridDdlPlace columns={4} titleForm={"Kota/Kabupaten"} isRequired={true} attribute={{ name: "kabupaten", value: data?.kabupaten }}
                            datahandler={(e) => {
                                handleChange(e.target.name, e.target.value);
                                GetKecamatan(kabupatens.find((item) => item.nama_kabupaten_kota === e.target.value).id_kabupaten_kota);
                            }}
                            datas={{ data: kabupatens, keyName: "id_kabupaten_kota", valueName: "nama_kabupaten_kota" }}
                            isLoading={isLoadingKabupaten}></GridDdlPlace>

                        {/* Row */}
                        <GridForm column={4} titleForm={"Tempat Lahir"} attribute={{ name: "tempat_lahir", value: data?.tempat_lahir }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Pekerjaan"} attribute={{ name: "pekerjaan", value: data?.pekerjaan }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridDdlPlace columns={4} titleForm={"Kecamatan"} isRequired={true} attribute={{ name: "kecamatan", value: data?.kecamatan }}
                            datahandler={(e) => {
                                handleChange(e.target.name, e.target.value);
                                GetKelurahan(kecamatans.find((item) => item.nama_kecamatan === e.target.value).id_kecamatan);
                            }} datas={{ data: kecamatans, keyName: "id_kecamatan", valueName: "nama_kecamatan" }} isLoading={isLoadingKecamatan}></GridDdlPlace>

                        {/* Row */}
                        <GridForm type={FORM_TYPE.DATEPICKER} column={4} titleForm={"Tanggal Lahir"} attribute={{ name: "tanggal_lahir", value: (data?.tanggal_lahir) ? dayjs(data.tanggal_lahir) : null }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Penghasilan Per Bulan"} attribute={{ name: "penghasilan", value: data?.penghasilan }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridDdlPlace columns={4} titleForm={"Kelurahan"} isRequired={true} attribute={{ name: "kelurahan", value: data?.kelurahan }}
                            datahandler={(e) => {
                                handleChange(e.target.name, e.target.value);
                            }} datas={{ data: kelurahans, keyName: "id_desa_kelurahan", valueName: "nama_desa_kelurahan" }} isLoading={isLoadingKelurahan}></GridDdlPlace>
                        {/* Row */}

                        {/* Row */}
                        <GridForm column={4} titleForm={"No HP"} attribute={{
                            name: "no_hp", value: data?.no_hp, type: "number"
                        }} isRequired={isPenanggungJawab} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Kode Pos"} attribute={{ name: "kode_pos", value: data?.kode_pos }} isRequired={false} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Email"} attribute={{ name: "email", value: data?.email }} isRequired={isPenanggungJawab} handleChange={handleChange}></GridForm>

                        {/* Row */}
                        <GridForm column={4} titleForm={"Nomor Induk Kependudukan (NIK)"} attribute={{ name: "nik", value: data?.nik, type: 'number' }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Hubungan dengan Calon Santri"} attribute={{ name: "hubungan_santri", value: data?.hubungan_santri }} isRequired={true} handleChange={handleChange}></GridForm>

                    </Grid>
                </CardContent>
            </Card>

        </>
    );
}

export default DataWali;